import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { Social } from "@/types/socials";
import { fetchSocials } from "@/api/socials";

type SocialPlatform = "email" | "instagram" | "telegram" | "youtube" | "tiktok";

export const useSocialsStore = defineStore("socials", () => {
  const socials = ref<Social[]>([]);
  const socialLinks = computed<Record<SocialPlatform, string | null>>(() => {
    const map: Record<SocialPlatform, string | null> = {
      email: null,
      instagram: null,
      telegram: null,
      youtube: null,
      tiktok: null,
    };

    for (const s of socials.value) {
      const platform = s.name as SocialPlatform;
      if (platform in map && s.url) {
        map[platform] = s.url;
      }
    }

    return map;
  });

  async function loadSocials() {
    if (socials.value.length > 0) {
      return socials.value;
    }
    try {
      socials.value = await fetchSocials();
    } catch (error) {
      console.error(error);
      return [];
    }

    return socials.value;
  }

  return { loadSocials, socialLinks };
});
